import { siteRoutes } from "@/routes/siteRoutesList";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import {
  GearIcon,
  HeartIcon,
  ReaderIcon,
  CardStackIcon,
  StarFilledIcon,
  Crosshair1Icon,
  DownloadIcon,
  MixIcon,
  ColorWheelIcon,
  ListBulletIcon,
} from "@radix-ui/react-icons";
import { ReactComponent as FallGuys } from "../assets/fallguysicon.svg";

export const DBG_siteRoutes = {
  "routes.headlines.main": [
    brand.hasFeature.posts && {
      title: "routes.rout.feed",
      link: siteRoutes["dashboard"],
      logo: CardStackIcon,
    },
    {
      title: "routes.route.leaderboard",
      link: siteRoutes["leaderboard"],
      logo: ListBulletIcon,
    },
  ],
  "routes.headlines.engagement": [
    brand.hasFeature.challenges && {
      title: "Counter-Strike 2",
      link: siteRoutes["counterstrike"],
      logo: Crosshair1Icon,
    },
    brand.hasFeature.challenges && {
      title: "Fall Guys Challenge",
      link: siteRoutes["fallguys"],
      logo: FallGuys,
    },
    brand.hasFeature.challenges && {
      title: "Forza Motorsport Challenge",
      link: siteRoutes["forzamotorsport"],
      logo: ColorWheelIcon,
    },
    brand.hasFeature.teams && {
      title: "routes.route.teams",
      link: siteRoutes["teams"],
      logo: HeartIcon,
    },
    brand.hasFeature.dailytasks && {
      title: "routes.route.dailyTasks",
      link: siteRoutes["dailytasks"],
      logo: MixIcon,
    },
  ],
  "routes.headlines.tracker": [
    brand.hasFeature.challenges && {
      title: "routes.route.gametracker",
      link: siteRoutes["gametracker"],
      logo: DownloadIcon,
    },
  ],
  "routes.headlines.updates": [
    brand.hasFeature.news && {
      title: "routes.route.news",
      link: siteRoutes["news"],
      logo: ReaderIcon,
    },
    brand.hasFeature.feedback && {
      title: "routes.route.feedback",
      link: siteRoutes["feedback"],
      logo: HeartIcon,
    },
    brand.hasFeature.schedule && {
      title: "routes.route.schedule",
      link: siteRoutes["schedule"],
      logo: undefined,
    },
    brand.hasFeature.winners && {
      title: "routes.route.winners",
      link: siteRoutes["winners"],
      logo: StarFilledIcon,
    },
  ],
  "routes.headlines.profile": [
    {
      title: "routes.route.settings",
      link: siteRoutes["profileSettings"],
      logo: GearIcon,
    },
  ],
};
